module.exports = __webpack_public_path__ + "static/media/place-24.a1a0d350.svg";